'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useAuthStore } from '@/stores/authStore';
import { creatorReferralsModal, useCreatorReferralsModalStore } from '@/lib/stores/creator-referrals-modal-store';
import { clearPendingReferralClaim, loadPendingReferralClaim } from '@/lib/referrals/claim-receipt';
import { loadStoredReferralAttribution, saveStoredReferralAttribution } from '@/lib/referrals/attribution';

/** 登录跳转后展示服务端领取结果；复用兑换弹窗的 loading/error/到账状态。 */
export function ReferralClaimRuntime() {
  const pathname = usePathname();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const userId = useAuthStore((state) => state.user?.id);
  const modalOpen = useCreatorReferralsModalStore((state) => state.isOpen);

  useEffect(() => {
    if (!isAuthenticated || !userId || !pathname || pathname === '/login' || modalOpen) return;
    const claim = loadPendingReferralClaim();
    if (!claim) return;
    if (claim.userId && claim.userId !== userId) { clearPendingReferralClaim(); return; }
    // 未绑定用户仍能在补录窗口内主动兑换，不能把注册成功误报为到账。
    if (!loadStoredReferralAttribution()) saveStoredReferralAttribution({ referralCode: claim.code });
    clearPendingReferralClaim();
    creatorReferralsModal.open('redeem', { source: 'manual' });
  }, [isAuthenticated, modalOpen, pathname, userId]);

  return null;
}
